export class VisitType {
    id = null;
    name = null;
    code = null;
    description = null;
}